import { createClient } from "@supabase/supabase-js";
import { trackPasswordRecovery } from "./passwordRecovery";

const SUPABASE_URL =
    process.env.REACT_APP_SUPABASE_URL ||
    process.env.NEXT_PUBLIC_SUPABASE_URL ||
    process.env.SUPABASE_URL;
const SUPABASE_ANON_KEY =
    process.env.REACT_APP_SUPABASE_ANON_KEY ||
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ||
    process.env.SUPABASE_ANON_KEY;

const hasSupabaseConfig = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);

// Lazily initialise the client so we only attempt to talk to Supabase when config is present.
const supabase = hasSupabaseConfig
    ? createClient(SUPABASE_URL, SUPABASE_ANON_KEY)
    : null;

// Register before React mounts: recovery can finish during client initialization.
supabase?.auth.onAuthStateChange(trackPasswordRecovery);

export function getSupabaseClient() {
    if (!supabase) {
        throw new Error(
            "Supabase is not configured. Set REACT_APP_SUPABASE_URL/REACT_APP_SUPABASE_ANON_KEY (or NEXT_PUBLIC_SUPABASE_URL/NEXT_PUBLIC_SUPABASE_ANON_KEY)."
        );
    }
    return supabase;
}

export { hasSupabaseConfig, SUPABASE_URL, SUPABASE_ANON_KEY };
